import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog, Paises } from '@models/base/identificadores.model';
import { ExpedienteSummaryDto } from '@models/expediente/expedienteSummary.model';
import { FueroService } from '@services/fuero/fuero.service';
import { JuridiccionService } from '@services/juridiccion/juridiccion.service';
import { JuzgadoService } from '@services/juzgado/juzgado.service';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from 'src/app/component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonDeleteComponent } from 'src/app/component/button-delete/button-delete.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { GoBackAndTitleComponent } from 'src/app/component/go-back-and-title/go-back-and-title.component';
import { CreateJuzgadoRequest } from '@models/juzgado/createJuzgadoResquest.model';
import { UpdateJuzgadoRequest } from '@models/juzgado/updateJuzgadoResquest.model';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { JuzgadoDto } from '@models/juzgado/juzgadoDto.model';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { map, Observable, of, startWith } from 'rxjs';
import { DtoBase } from '@models/base/dtoBase.model';
import { PaisesService } from '@services/pais/paises.service';
import { PaisService } from '@services/pais/pais.service';
import { EmpresaUsuarioService } from '@services/empresaUsuario/empresaUsuario.service';
import { EmpresaUsuarioDto } from '@models/empresaUsuario/empresaUsuarioDto.model';
import { BuscarLocalidadComponent } from '@views/busquedas/buscar-localidad/buscar-localidad.component';
import { BuscarProvinciaGeorefComponent } from '@views/busquedas/buscar-provincia-georef/buscar-provincia-georef.component';
import { BuscarLocalidadGeorefComponent } from '@views/busquedas/buscar-localidad-georef/buscar-localidad-georef.component';
import { BuscarProvinciaLocalidadGeorefComponent } from '@views/busquedas/buscar-provincia-localidad-georef/buscar-provincia-localidad-georef.component';
import { LocalidadBasicDto } from '@models/localidad/localidadBasicDto.model';

@Component({
  selector: 'app-dialog-form-juzgado',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, ButtonDeleteAndCancelComponent, ButtonCloseComponent, MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatInputModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCloseDialogComponent, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, BuscarLocalidadComponent,BuscarProvinciaGeorefComponent, BuscarLocalidadGeorefComponent,BuscarProvinciaLocalidadGeorefComponent],
  templateUrl: './dialog-form-juzgado.component.html',
  styleUrl: './dialog-form-juzgado.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogFormJuzgadoComponent {
  estadosjuzgado!: BaseDto[];
  expedienteDto!: ExpedienteSummaryDto;
  fueros!: BaseDto[];
  jurisdicciones!: BaseDto[];
  filteredJurisdiccionOptions!: Observable<DtoBase[]>;
  filteredFuerosOptions!: Observable<DtoBase[]>;
  paises!: BaseDto[];
  empresaUsuarioDto!: EmpresaUsuarioDto;
  localidad!: BaseDto;
  juzgado: any;
  provinciaSeleccionada: any;
  get f() { return this.form.controls; }
  accionesDialog = AccionesDialog;
  form!: FormGroup;
  localData: any;
  formBuilder: FormBuilder = new FormBuilder;
  tiposjuzgado!: BaseDto[];
  juzgadoDto!: JuzgadoDto;

  constructor(
    public dialogRef: MatDialogRef<DialogFormJuzgadoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private juridiccionService: JuridiccionService,
    private fueroService: FueroService,
    private juzgadoService: JuzgadoService,
    private paisService: PaisService,

    private empresaUsuarioService: EmpresaUsuarioService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
  ) {

    this.getAllJurisdicciones();
    this.getAllFueros();
    //this.getAllPaises();
  }

  ngOnInit(): void {
    this.juzgado = this.data?.juzgado || {};
    this.setForm();
    // if(this.juzgado)
    //    this.getJuzgadoById(this.juzgado.id)




  }

  setForm(){
    this.form = this.formBuilder.group({
      Descripcion: [this.juzgado.descripcion || '', Validators.compose([Validators.maxLength(100)])],
      Observaciones: [this.juzgado.observaciones || '', Validators.compose([Validators.maxLength(500)])],
      Nombre: [this.juzgado.nombre || '', Validators.compose([Validators.required, Validators.maxLength(100)])],
      Domicilio: [this.juzgado.domicilio || '', Validators.compose([Validators.maxLength(200)])],
      Telefono: [this.juzgado.telefono || '', Validators.compose([Validators.maxLength(50)])],
      Correo: [this.juzgado.correo || '', Validators.compose([Validators.email, Validators.maxLength(100)])],
      Region: [this.juzgado.region || '', Validators.compose([Validators.maxLength(100)])],
      IdLocalidad: [this.juzgado?.idLocalidad || null],
      IdPais: [Paises.Argentina],
      IdJurisdiccion: [null,],
      IdFuero: [null,],
      Nominacion: [this.juzgado.nominacion || '', Validators.compose([Validators.maxLength(100)])],
      Subnominacion: [this.juzgado.subnominacion || '', Validators.compose([Validators.maxLength(100)])],
      Competencia: [this.juzgado.competencia || '', Validators.compose([Validators.maxLength(100)])],
      Grado: [this.juzgado.grado || '', Validators.compose([Validators.maxLength(100)])],
      Numero: [this.juzgado.numero || '', Validators.compose([Validators.maxLength(20)])],
      Letra: [this.juzgado.letra || '', Validators.compose([Validators.maxLength(5)])],
      EsActivo: [this.juzgado.esActivo || true],
      EsSecretaria: [this.juzgado.esSecretaria || false],
      TieneMesaVirtual: [this.juzgado.tieneMesaVirtual || false],
      HorarioAtencion: [this.juzgado.horarioAtencion || '', Validators.compose([Validators.maxLength(100)])],
      UrlSistemaGestion: [this.juzgado.urlSistemaGestion || '', Validators.compose([Validators.maxLength(200)])],
    });
  }


onLocalidadSeleccionada(localidad: any): void {
  this.juzgado.idLocalidad = localidad.id;
  this.form.get('IdLocalidad')?.setValue(this.juzgado.idLocalidad);
}

  seleccionaLocalidad(data: BaseDto) {
    this.localidad = data
  }
  getAllJurisdicciones() {
    this.spinner.show('spJurisdicciones')
    this.juridiccionService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spJurisdicciones')
          this.jurisdicciones = data

          this.filteredJurisdiccionOptions = this.form.get('IdJurisdiccion')!.valueChanges.pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value?.descripcion),
            map(descripcion => this.filterJurisdicciones(descripcion || ''))
          );


          if (this.juzgado.jurisdiccion) {
            const jurisdiccion = this.jurisdicciones.find(j => j.id === this.juzgado.jurisdiccion.id);
            if (jurisdiccion) this.form.patchValue({ IdJurisdiccion: jurisdiccion });
          }

        },
        error => {
          this.spinner.hide('spJurisdicciones')
          this.snackBar.showError(error, "Error");
        })
  }

  private filterJurisdicciones(value: string): DtoBase[] {
    const filterValue = value.toLowerCase();
    return this.jurisdicciones.filter(option =>
      option.descripcion?.toLowerCase().includes(filterValue)
    );
  }

  displayJurisdiccionFn(jurisdiccion: DtoBase): string {
    return jurisdiccion ? jurisdiccion.descripcion : '';
  }

  setJurisdiccionPorId(id: number) {
    const jurisdiccionSeleccionado = this.jurisdicciones.find(j => j.id === id);
    if (jurisdiccionSeleccionado) {
      this.form.get('IdJurisdiccion')?.setValue(jurisdiccionSeleccionado);
    }
  }

  getAllFueros() {
    this.spinner.show('spFueros')
    this.fueroService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spFueros')
          this.fueros = data

          this.filteredFuerosOptions = this.form.get('IdFuero')!.valueChanges.pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value?.descripcion),
            map(descripcion => this.filterFueros(descripcion || ''))
          );

          if (this.juzgado.fuero) {
            const fuero = this.fueros.find(f => f.id === this.juzgado.fuero.id);
            if (fuero) this.form.patchValue({ IdFuero: fuero });
          }

        },
        error => {
          this.spinner.hide('spFueros')
          this.snackBar.showError(error, "Error");
        })
  }

  selectFuero(): void {
    const seleccion = this.form.get('IdFuero')!.value as DtoBase;
    if (seleccion && seleccion.id) {
      // Aquí ejecutás tu lógica con la jurisdicción seleccionada
      console.log('Jurisdicción seleccionada:', seleccion);
      // ej: this.cargarDatosPorJurisdiccion(seleccion.id);
    }
  }

  private filterFueros(value: string): DtoBase[] {
    const filterValue = value.toLowerCase();
    return this.fueros.filter(option =>
      option.descripcion?.toLowerCase().includes(filterValue)
    );
  }

  displayFueroFn(fuero: DtoBase): string {
    return fuero ? fuero.descripcion : '';
  }
  displayIdFueroFn(fuero: DtoBase): number {
    return fuero ? fuero.id : 0;
  }

  setFueroPorId(id: number) {
    const fueroSeleccionado = this.fueros.find(j => j.id === id);
    if (fueroSeleccionado) {
      this.form.get('IdFuero')?.setValue(fueroSeleccionado);
    }
  }

  getAllPaises() {
    this.spinner.show('spPaises')
    this.paisService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spPaises')
          this.paises = data

        },
        error => {
          this.spinner.hide('spPaises')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllUsuarioByIdEmpresa() {
    this.spinner.show('spPaises')
    this.empresaUsuarioService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spPaises')
          const empresaUsuarioDtoEncontrado = data.find(x => x.usuario.id === this.loginService.getIdUser());
          if (empresaUsuarioDtoEncontrado) {
            this.empresaUsuarioDto = empresaUsuarioDtoEncontrado;
            //this.form.get('IdPais')?.setValue(this.empresaUsuarioDto.empresa.pais.id);
          }

        },
        error => {
          this.spinner.hide('spPaises')
          this.snackBar.showError(error, "Error");
        })
  }

  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.form.controls['IdExpediente'].setValue(this.expedienteDto.id)
  }

  cancelar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }



  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.spinner.show("spJuzgado")
    this.juzgadoService.create(this.setCreateJuzgadoRequest())
      .subscribe(
        data => {
          this.spinner.hide("spJuzgado")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.juzgado, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spJuzgado")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spJuzgado")
    this.juzgadoService.update(this.setUpdateJuzgadoRequest())
      .subscribe(
        data => {
          this.spinner.hide("spJuzgado")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.juzgado, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spJuzgado")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spJuzgado")
    this.juzgadoService.delete(this.data.juzgado.id)
      .subscribe(
        data => {
          this.spinner.hide("spJuzgado")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.juzgado, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spJuzgado")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateJuzgadoRequest(): CreateJuzgadoRequest {

    const createJuzgadoRequest = new CreateJuzgadoRequest();

    createJuzgadoRequest.nombre = this.form.controls['Nombre'].value;
    createJuzgadoRequest.domicilio = this.form.controls['Domicilio'].value;
    createJuzgadoRequest.telefono = this.form.controls['Telefono'].value == "" ? null : this.form.controls['Telefono'].value;
    createJuzgadoRequest.descripcion = this.form.controls['Descripcion'].value;
    createJuzgadoRequest.observaciones = this.form.controls['Observaciones'].value;
    createJuzgadoRequest.region = this.form.controls['Region'].value == "" ? null : this.form.controls['Region'].value;
    createJuzgadoRequest.idLocalidad = this.form.controls['IdLocalidad'].value == "" ? null : this.form.controls['IdLocalidad'].value;
    createJuzgadoRequest.correo = this.form.controls['Correo'].value == "" ? null : this.form.controls['Correo'].value;
    createJuzgadoRequest.idPais = this.form.controls['IdPais'].value == "" ? null : this.form.controls['IdPais'].value;
    let jurisdiccion = this.form.controls['IdJurisdiccion'].value == "" ? null : this.form.controls['IdJurisdiccion'].value;
    createJuzgadoRequest.idJurisdiccion = jurisdiccion?.id ?? null;
    let fuero = this.form.controls['IdFuero'].value == "" ? null : this.form.controls['IdFuero'].value;
    createJuzgadoRequest.idFuero = fuero?.id ?? null
    createJuzgadoRequest.nominacion = this.form.controls['Nominacion'].value == "" ? null : this.form.controls['Nominacion'].value;
    createJuzgadoRequest.subnominacion = this.form.controls['Subnominacion'].value == "" ? null : this.form.controls['Subnominacion'].value;
    createJuzgadoRequest.competencia = this.form.controls['Competencia'].value == "" ? null : this.form.controls['Competencia'].value;
    createJuzgadoRequest.grado = this.form.controls['Grado'].value == "" ? null : this.form.controls['Grado'].value;
    createJuzgadoRequest.numero = this.form.controls['Numero'].value == "" ? null : this.form.controls['Numero'].value;
    createJuzgadoRequest.letra = this.form.controls['Letra'].value == "" ? null : this.form.controls['Letra'].value;
    createJuzgadoRequest.esActivo = this.form.controls['EsActivo'].value == false ? false : this.form.controls['EsActivo'].value;
    createJuzgadoRequest.esSecretaria = this.form.controls['EsSecretaria'].value == false ? false : this.form.controls['EsSecretaria'].value;
    createJuzgadoRequest.tieneMesaVirtual = this.form.controls['TieneMesaVirtual'].value == false ? false : this.form.controls['TieneMesaVirtual'].value;
    createJuzgadoRequest.horarioAtencion = this.form.controls['HorarioAtencion'].value == "" ? null : this.form.controls['HorarioAtencion'].value;
    createJuzgadoRequest.urlSistemaGestion = this.form.controls['UrlSistemaGestion'].value == "" ? null : this.form.controls['UrlSistemaGestion'].value;

    return createJuzgadoRequest
  }

  setUpdateJuzgadoRequest(): UpdateJuzgadoRequest {

    const updateJuzgadoRequest = new UpdateJuzgadoRequest();
    updateJuzgadoRequest.id = this.form.controls['Id'].value;
    updateJuzgadoRequest.nombre = this.form.controls['Nombre'].value;
    updateJuzgadoRequest.domicilio = this.form.controls['Domicilio'].value;
    updateJuzgadoRequest.telefono = this.form.controls['Telefono'].value == "" ? null : this.form.controls['Telefono'].value;
    updateJuzgadoRequest.descripcion = this.form.controls['Descripcion'].value;
    updateJuzgadoRequest.observaciones = this.form.controls['Observaciones'].value;
    updateJuzgadoRequest.region = this.form.controls['Region'].value == "" ? null : this.form.controls['Region'].value;
    updateJuzgadoRequest.idLocalidad = this.form.controls['IdLocalidad'].value == "" ? null : this.form.controls['IdLocalidad'].value;
    updateJuzgadoRequest.correo = this.form.controls['Correo'].value == "" ? null : this.form.controls['Correo'].value;
    updateJuzgadoRequest.idPais = this.form.controls['IdPais'].value == "" ? null : this.form.controls['IdPais'].value;
    let jurisdiccion = this.form.controls['IdJurisdiccion'].value == "" ? null : this.form.controls['IdJurisdiccion'].value;
    updateJuzgadoRequest.idJurisdiccion = jurisdiccion?.id ?? null
    let fuero = this.form.controls['IdFuero'].value == "" ? null : this.form.controls['IdFuero'].value;
    updateJuzgadoRequest.idFuero = fuero?.id ?? null
    updateJuzgadoRequest.nominacion = this.form.controls['Nominacion'].value == "" ? null : this.form.controls['Nominacion'].value;
    updateJuzgadoRequest.subnominacion = this.form.controls['Subnominacion'].value == "" ? null : this.form.controls['Subnominacion'].value;
    updateJuzgadoRequest.competencia = this.form.controls['Competencia'].value == "" ? null : this.form.controls['Competencia'].value;
    updateJuzgadoRequest.grado = this.form.controls['Grado'].value == "" ? null : this.form.controls['Grado'].value;
    updateJuzgadoRequest.numero = this.form.controls['Numero'].value == "" ? null : this.form.controls['Numero'].value;
    updateJuzgadoRequest.letra = this.form.controls['Letra'].value == "" ? null : this.form.controls['Letra'].value;
    updateJuzgadoRequest.esActivo = this.form.controls['EsActivo'].value == false ? false : this.form.controls['EsActivo'].value;
    updateJuzgadoRequest.esSecretaria = this.form.controls['EsSecretaria'].value == false ? false : this.form.controls['EsSecretaria'].value;
    updateJuzgadoRequest.tieneMesaVirtual = this.form.controls['TieneMesaVirtual'].value == false ? false : this.form.controls['TieneMesaVirtual'].value;
    updateJuzgadoRequest.horarioAtencion = this.form.controls['HorarioAtencion'].value == "" ? null : this.form.controls['HorarioAtencion'].value;
    updateJuzgadoRequest.urlSistemaGestion = this.form.controls['UrlSistemaGestion'].value == "" ? null : this.form.controls['UrlSistemaGestion'].value;

    return updateJuzgadoRequest
  }

  onReset() {
    this.form.reset();
  }

  trackByjuzgados(index: number, juzgado: any): any { return juzgado; }



  async getJuzgadoById(id: number) {
    this.spinner.show("spView")
    await this.juzgadoService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spView")
          this.juzgadoDto = data
          this.setForm();
        },
        error => {
          this.spinner.hide("spView")
          this.snackBar.showError(error, "Error");
        })
  }

  esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  abrirUrl(url: string): void {
    if (this.esUrlValida(url)) {
      window.open(url, '_blank');
    }
  }
}
